<template>
  <div id="personal" class="personal" :style="`height:${clientHeight}px`">
    <div v-show="serviceDetailStatus" style="padding-top: 20px">
      <div class="leftside">
        <div class="fix-container">
          <div>
            <div class="profile">
              <div @click="openImageReplace(userInfo.photo)" class="avatar">
                <img ref="avatarImageDOM" v-if="getUserLoginStatus" :src="$store.state.photoUrl + userInfo.avatar"
                     alt=""/>
              </div>
              <p @click="openProfiles" class="username">{{userInfo.userName}}</p>
              <p class="userzw">{{userInfo.remark}}</p>
            </div>
          </div>
          <ul class="toolslist">
            <!--          <li v-for="item in leftMenu" :class="currentLeftText === item.text? 'currentRed':''"-->
            <!--              @click="onLeftMenu(item.id, item.text)">-->
            <!--            <i :class="`iconfont ${item.icon}`"></i>-->
            <!--            <p>{{item.text}}</p>-->
            <!--          </li>-->
            <!--          :class="currentLeftText === '开放预约'? 'currentRed':''"-->
            <li v-if="userInfo.extend.kfyy" @click="showOrderPanel">
              <span>
                <i class="icon-font bcsxuinformation"></i>
              </span>
              <p>开放预约</p>
            </li>
            <template v-if="userInfo.extend && userInfo.extend.noticeSortList.length">
              <li :class="currentLeftText === '发布通知公告'? 'currentRed':''" @click="showCreateNotice">
                <span>
                  <i class="icon-font bcsxuziyuan4"></i>
                </span>
                <p>发布通知公告</p>
              </li>
              <li v-if="userInfo.extend.tzggAdmin" @click="showNoticeVerifyPanel">
                <span><i class="icon-font bcsxuinformation"></i></span>

                <p>通知公告审核</p>
              </li>
            </template>
            <div class="popularTitleBox">
              <div class="box">
                <span>常用统计</span>
              </div>
            </div>
            <li @click="toServiceDetail(item)" v-for="item in popularData">
              <span>
                <img :src="item.icon" alt="">
              </span>
              <p :title="item.name">{{item.name}}</p>
            </li>

          </ul>
        </div>
      </div>
      <div class="mainContainer">
        <div class="header">
          <div class="right">
            {{weatherInfo}}
            <span>{{currTime}}</span>
          </div>
          <div class="left">
            <div class="inner">
              <input @keypress.13="execSearchAction" v-model="searchText" class="searchinput"
                     placeholder="搜索您想办的事务..."
                     type="text"/>
              <button @click="execSearchAction"><i class="iconfont icon-ai219"></i></button>
            </div>
          </div>

        </div>
        <div v-if="isShowSearchArea" class="searchResult">
          <p class="searchNotice">您搜索的关键词:<span>{{searchText}}</span>
            <button @click="closeSearch" class="back">返回</button>
          </p>
          <div v-if="searchResultData.message" v-show="searchResultData.message.list.length" class="group">
            <h2>消息：</h2>
            <ul class="resultlist">
              <li @click="openMsgDetail(message)" v-for="message in searchResultData.message.list">
                <h3>{{message.title}}</h3>
                <p>{{message.content}}</p>
                <span>{{message.time}}</span>
              </li>
            </ul>
            <div v-if="searchResultData.message.pageNumber<searchResultData.message.pageCount"
                 @click="searchListLoadMore(searchResultData.message,2)" class="loadmore">加载更多
            </div>
          </div>
          <div v-if="searchResultData.work" v-show="searchResultData.work.list.length" class="group">
            <h2>待办：</h2>
            <ul class="resultlist">
              <li @click="openDetail(work)" v-for="work in searchResultData.work.list">
                <h3>{{work.workTitle}}</h3>
                <p>{{work.content}}</p>
                <span>{{work.time}}</span>
              </li>
            </ul>
            <div v-if="searchResultData.work.pageNumber<searchResultData.work.pageCount"
                 @click="searchListLoadMore(searchResultData.work,4)" class="loadmore">加载更多
            </div>
          </div>
          <div v-if="searchResultData.schedule" v-show="searchResultData.schedule.list.length" class="group">
            <h2>日程：</h2>
            <ul class="resultlist">
              <li @click="searchToScheduleDetail(schedule)" v-for="schedule in searchResultData.schedule.list">
                <h3>{{schedule.title}}</h3>
                <p>{{schedule.content}}</p>
                <span>{{schedule.time}}</span>
              </li>
            </ul>


            <div v-if="searchResultData.schedule.pageNumber<searchResultData.schedule.pageCount"
                 @click="searchListLoadMore(searchResultData.schedule,1)" class="loadmore">加载更多
            </div>
          </div>
          <div v-if="searchResultData.notice" v-show="searchResultData.notice.list.length" class="group">
            <h2>通知公告：</h2>
            <ul class="resultlist">
              <li @click="openNoticeDetail(notice)" v-for="notice in searchResultData.notice.list">
                <h3>{{notice.title}}</h3>
                <p v-html="notice.content"></p>
                <span>{{notice.time}}</span>
              </li>
            </ul>
            <div v-if="searchResultData.notice.pageNumber<searchResultData.notice.pageCount"
                 @click="searchListLoadMore(searchResultData.notice,3)" class="loadmore">加载更多
            </div>
          </div>
        </div>
        <div v-if="!isShowSearchArea" class="coreContent" style="padding-bottom: 100px">
          <div class="row">
            <div class="module left">
              <h2>日程<i style="margin-left: 10px" title="回到今天" @click="calendarToToday"
                         class="iconfont icon-shuaxin"></i>

                <switch-comp @toggle="toggleCalendar"></switch-comp>
                <span style="display: none" @click="showScheduleDetail" class="detail">详情 ></span>
              </h2>

              <div style="display: none;" class="info">
                <p>第1学期 第10周</p>
                <span><i class="iconfont icon-shuaxin"></i></span>
              </div>
              <calendar @getWeather="getWeather" ref="calendarComp"></calendar>
            </div>

            <div class="middle">
              <div class="inner module todo">
                <div class="nav-tabs-navigation">
                  <div class="nav-tabs-wrapper">
                    <ul role="tablist" class="nav nav-tabs" style="float:left;">
                      <li @dblclick="changeTodoTabTitle" @click="changeTodoTab(todoTab.id)"
                          v-for="(todoTab,index) in todoListTab" class="tab"
                          :class="{'active':todoTab.id===currentSelectTodoListTab}"><a class="active_tab tabs__link">
                        <span v-if="!todoTab.isEdit" class="title title_center">{{todoTab.title}}</span></a>
                      </li>
                    </ul>
                    <div class="filterContainer" v-if="currentSelectTodoListTab !== 4">
                      <multiselect v-model="todoFilterCate"
                                   :options="getTodoCategory"
                                   :label="'title'"
                                   placeholder="请选择类别"
                                   :multiple="false"
                                   :show-labels="false"
                                   :clear-on-select="false"
                                   :close-on-select="true"
                                   :allow-empty="true"
                                   :taggable="true"
                                   @select="selectTodoCate"
                                   :allowEmpty="false"

                      ></multiselect>
                    </div>
                    <div @click="showTodoDetail(null,{},currentSelectTodoListTab)" class="detail">
                      详情 >
                    </div>
                  </div>
                </div>

                <transiton name="tabToggle">
                  <ul v-if="currentSelectTodoListTab === 4" class="todolist copyTo">
                    <p v-if="copyData===null" class="noticeText">Loading...</p>
                    <p v-else-if="!copyData.length" class="noticeText">暂无数据</p>
                    <li @click="showTodoDetail(4,item)" v-for="(item, index) in copyData" :key="index">
                      <span>{{item.processChName}}</span>
                      <span>共{{item.num}}条</span>
                    </li>
                  </ul>
                </transiton>
                <transition name="tabToggle">
                  <ul v-if="currentSelectTodoListTab===1" class="todolist">
                    <p v-if="todoData.receive===null" class="noticeText">Loading...</p>
                    <p v-else-if="!todoData.receive.length" class="noticeText">暂无数据</p>
                    <li @click="showTodoDetail(1,sysInfo)" v-for="sysInfo in todoData.receive">
                      <div class="icon">
                        <img :src="sysInfo.icon" alt=""/>
                      </div>
                      <div class="info">
                        <h2 :class="{hold:sysInfo.titleList.length === 0}">{{sysInfo.sysname}}<p v-if="sysInfo.from">
                          来自：{{sysInfo.from}}</p></h2>
                        <div>
                          <template v-if="false">
                            <breath-text :num="sysInfo.receiveRunningnum"></breath-text>
                          </template>
                          <p>待办理: <span>{{sysInfo.receiveRunningnum}}</span></p>
                          <p @click.stop="showTodoDetail(3,sysInfo)">已办理:<span>{{sysInfo.receiveDonenum}}</span></p>
                          <p class="date">{{sysInfo.time | convertTimeToDate}}</p>
                        </div>
                        <p v-if="sysInfo.titleList.length > 0">
                          <scroll-title :data="sysInfo.titleList" @clickItem="openTodoHandle"></scroll-title>
                        </p>
                      </div>
                    </li>
                  </ul>
                </transition>
                <transition name="tabToggle">
                  <ul v-if="currentSelectTodoListTab===0" class="todolist">
                    <p v-if="todoData.send===null" class="noticeText">Loading...</p>
                    <p v-else-if="!todoData.send.length" class="noticeText">暂无数据</p>
                    <li @click="showTodoDetail(2,sysInfo)" v-for="sysInfo in todoData.send">
                      <div class="icon">
                        <img :src="sysInfo.icon" alt=""/>
                      </div>
                      <div class="info">
                        <h2 :class="{hold:sysInfo.titleList.length === 0}">{{sysInfo.sysname}}<p v-if="sysInfo.from">
                          来自：{{sysInfo.from}}</p></h2>
                        <div>
                          <p @click.stop="showTodoDetail(2,sysInfo,null,0)">
                            进行中:<span>{{sysInfo.sendRunningNum}}</span>
                          </p>
                          <p @click.stop="showTodoDetail(2,sysInfo,null,1)">已完结:<span>{{sysInfo.sendDonenum}}</span>
                          </p>
                          <p class="date">{{sysInfo.time | convertTimeToDate}}</p>
                        </div>
                        <p v-if="sysInfo.titleList.length > 0">
                          <scroll-title :data="sysInfo.titleList" @clickItem="openTodoHandle"></scroll-title>
                        </p>
                      </div>
                    </li>
                  </ul>
                </transition>
              </div>
            </div>
          </div>
          <div class="row">
            <!--            <div class="half">-->
            <!--              <div class="inner module">-->
            <!--                <h2>应用系统</h2>-->
            <!--                <slide-app-list className="system" :data="serviceData"></slide-app-list>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--            <div class="half">-->
            <!--              <div class="inner module">-->
            <!--                <h2>微应用</h2>-->
            <!--                <slide-app-list className="service" :data="microServiceList"></slide-app-list>-->
            <!--              </div>-->
            <!--            </div>-->


            <div class="module left personalData">
              <h2>个人数据</h2>
              <div class="content">
                <div v-if="!personalInfo.length" class="empty">
                  暂无个人数据
                </div>
                <ul class="datalist">

                  <li @click="toPersonalDataDetail(item)" v-for="item in personalInfo">
                    <div class="item-icon">
                      <img :src="item.iconPath" :alt="item.sysname"/>
                    </div>
                    <h2>{{item.sysname}}</h2>
                    <p v-html="$options.filters.templateReplace(item.describe,item.num)"></p>
                  </li>


                </ul>
              </div>
            </div>
            <div class="middle">
              <div class="noticeBox">
                <div class="noticeTitle">
                  <div class="noticeTitleLeft">
                    <h2>通知公告(邮箱)</h2>
                  </div>
                  <div class="noticeTitleRight">
                    <div class="noticeOptions">
                    <span v-for="(item, index) in noticeListTab"
                          :class="currentSelectNoticeListTab === item.id ? 'optionsActive':''"
                          @click="changeNoticeTab(item.id)" :key="index">{{item.title}}</span>
                    </div>
                    <div class="detail" @click="showNoticeDetail">
                      <span>详情></span>
                    </div>
                  </div>
                </div>
                <div class="noticeCon">
                  <div class="noticeItem" @click="openNoticeDetail(item)" v-if="currentSelectNoticeListTab === 0"
                       v-for="(item, index) in noticeListTab[0].list">
                    <div class="noticeItemLeft">
                      {{item.title}}
                    </div>
                    <div class="noticeItemRight">
                      {{item.time | noticeTimeFilter}}
                    </div>
                  </div>
                  <div class="noticeItem" @click="openNoticeDetail(item)" v-if="currentSelectNoticeListTab === 1"
                       v-for="(item, index) in noticeListTab[1].list">
                    <div class="noticeItemLeft">
                      {{item.title}}
                    </div>
                    <div class="noticeItemRight">
                      {{item.time}}
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>
          <div class="row">
            <div class="appBox">
              <div class="appTitle">
                <div class="appTitleLeft">
                  <div class="appOptions">
                    <div class="appOptionsItem" @click="changeAppTab(item.id)"
                         :class="currentSelectAppListTab === item.id? 'appOptionsItemActive':''"
                         v-for="(item, index) in appListTab" :key="index">
                      <span>{{item.title}}</span>
                    </div>
                  </div>
                </div>
                <div class="appTitleRight" @click="onMore">
                  查看更多>
                </div>
              </div>
              <div class="appCon">
                <slide-app-list v-if="currentSelectAppListTab === 1" className="system"
                                :data="microServiceList"></slide-app-list>
                <slide-app-list v-if="currentSelectAppListTab === 0" className="system"
                                :data="serviceData"></slide-app-list>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div @click="toggleAppList" v-if="appCustom.isAppListShow" class="applistmask"></div>
      <transition name="appListAnim">
        <div v-if="appCustom.isAppListShow" class="applist">
          <ul class="tablist">
            <li v-for="tab in appCustom.tabs" :class="{'on':tab.id===appCustom.selectedTab}"
                @click="setAppListTab(tab.id)">
              <i class="iconfont" :class="tab.icon"></i>
              {{tab.title}}
              <span class="line"></span>
            </li>
          </ul>
          <div class="search">
            <i class="iconfont icon-ai219"></i>
            <input placeholder="请输入要搜索的关键词" type="text"/>
          </div>
          <ul class="contentList">
            <li>
              <ul class="left">
                <li v-for="cate in appCustom.cates" :class="{'on':cate.id===appCustom.selectedCate}"
                    @click="setAppListCate(cate.id)">{{cate.title}}
                </li>
              </ul>
              <ul class="right">
                <div v-if="customAppInBuilding" class="building">正在建设中...</div>
                <li v-if="!customAppInBuilding">
                  <img src="http://192.168.1.125:80/homepage/uploads/30829eb5-888f-4059-8a29-3dff7603b735.png" alt=""/>
                  <p>应用1</p>
                  <span>
                  <i class="iconfont icon-jia"></i>
                </span>
                </li>
              </ul>
            </li>
          </ul>
          <div @click="toggleAppList" class="close">
            <i class="iconfont icon-zuojiantou"></i>
          </div>
        </div>
      </transition>
      <personal-data></personal-data>
      <sys-nav-sort></sys-nav-sort>
    </div>
    <div class="detailBox" v-if="!serviceDetailStatus" :style="`min-height:${clientHeight}px`">
      <serviceDetail :detailData="serviceDetailData" @closeServiceDetail="closeServiceDetail"></serviceDetail>
    </div>
  </div>
</template>

<script>
  //通信总线
  import Bus from 'common/js/bus.js';
  //tab选项卡
  import {VueTabs, VTab} from 'vue-nav-tabs'
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex';
  //业务直通车
  import servicebox from 'components/personal/servicebox';
  //日历
  import calendar from 'components/schedule/calendar';
  //待办：滚动文字
  import scrollTitle from 'components/globalComp/scrollTitle';
  //axios
  import axios from 'axios'
  import apiConfig from 'common/js/api_config';
  import rating from "components/globalComp/rating"

  //个人数据详情
  import personalData from 'components/personal/personalDataModal';
  //日程切换开关
  import switchComp from 'components/globalComp/switch'
  //应用系统排序面板
  import sysNavSort from 'components/personal/sysNavSort'
  //多选
  import multiselect from 'vue-multiselect'
  // 应用列表
  import serviceModel from 'components/personal/serviceModel'
  import {getOneDayCustomDateStr} from "common/js/getToday"
  import slideAppList from "../components/personal/slideAppList";
  import breathText from "../components/personal/breathText";
  import serviceDetail from "components/service/serviceDetail"
  import serviceDetailMixin from "./mixin/serviceDetail";

  console.log("calendar-->>>")
  console.log(calendar)
  export default {
    name: "personal",
    mixins: [serviceDetailMixin],
    data: function () {
      return {
        currentTimeInfo: '',
        currentLeftText: '一张表',
        copyData: [],
        systemAppList: [],
        systemAppName: '',
        iframePrefix: '',
        iframeSrc: 'http://jkttb.itdaka.cn:8081/shall/cgi-bin/access/a2d3774f5cf84dd18469ec0501db2c41?url=http://jkttb.itdaka.cn:8083/lightapp/awatch/user/login&state=006EC7',
        //个人数据
        personalInfo: [],
        appCustom: {
          tabs: [
            {
              title: "我的收藏",
              id: 0,
              icon: "icon-shoucang"
            },
            {
              title: "可用应用",
              id: 1,
              icon: "icon-ai-list"
            },
            {
              title: "可用卡片",
              id: 2,
              icon: "icon-yingyongzhongxin"
            }
          ],
          cates: [
            {
              title: "全部",
              id: 0,
            },
          ],

          isAppListShow: 0,
          selectedTab: 0,
          selectedCate: 0
        },
        clientHeight: 0,
        optionsList: [
          {
            id: 1,
            text: '基本信息',
            items: [
              {
                id: 10,
                text: '家庭成员'
              },
              {
                id: 11,
                text: '学籍异动'
              },
              {
                id: 12,
                text: '学生成绩'
              }
            ]
          },
          {
            id: 2,
            text: '个人发展'
          },
          {
            id: 3,
            text: '科学研究'
          },
          {
            id: 4,
            text: '教育教学'
          },
          {
            id: 5,
            text: '资产信息'
          },
          {
            id: 6,
            text: '个人薪资'
          },
          {
            id: 7,
            text: '图书馆里'
          },
          {
            id: 8,
            text: '一卡通'
          }

        ],
        //待办分类
        todoListTab: [
          {
            id: 0,
            title: "发出的事项",
            isEdit: false
          },
          {
            id: 1,
            title: "收到的事项",
            isEdit: false
          },
          {
            id: 4,
            title: "抄送我的",
            isEdit: false
          },
        ],
        currentSelectTodoListTab: 1,

        //通知公告分类
        noticeListTab: [
          {
            id: 0,
            title: "最新",
            isEdit: false,
            list: []

          },
          {
            id: 1,
            title: "往日",
            isEdit: false,
            list: []
          }
        ],
        currentSelectNoticeListTab: 0,
        appListTab: [
          {
            id: 0,
            title: '应用系统',
            list: []
          },
          {
            id: 1,
            title: '微服务',
            list: []
          }
        ],
        currentSelectAppListTab: 0,
        //热门服务数据
        serviceData: [],
        //微服务列表
        microServiceList: [],

        //公共服务
        publicService: [],
        //常用服务
        morePublicService: [],
        isShowMorePublicService: false,
        /***
         * 个人中心应用组件类型：
         * 日程、待办、个人数据、通知公告、应用容器、卡片应用
         *
         */
        //应用卡片布局

        customAppInBuilding: true,
        customAppCard: [
          {
            direction: 'toleft',
            payload: [0, 0]
          },
          {
            direction: 'toright',
            payload: [
              {
                type: "card",
              }
            ]
          },

        ],

        testTodoTitleArray: [
          {
            title: "13123123123123",
            id: 123
          },
          {
            title: "4564565456456456",
            id: 456
          },
          {
            title: "7897897897897889",
            id: 789
          },

        ],
        todoData: {
          send: null,
          receive: null,
        },
        todoFilterCate: null,

        isShowSearchArea: false,
        searchText: null,
        searchInWaiting: null,
        //搜索结果列表
        searchResultData: {},
        searchPageSize: 5,
        searchPageNumber: 1,

        //待办办理绝对路径前缀
        todoHandlePathPre: '',

        weatherInfo: null,
        currTime: null,

        centerStatus: false,
        centerCode: 1,
        leftMenu: [
          {
            id: 1,
            text: '一张表',
            icon: 'icon-rili'
          },
          {
            id: 2,
            text: '微服务',
            icon: 'icon-weifuwu'

          },
          {
            id: 3,
            text: '应用系统',
            icon: 'icon-ziyuan11'
          },
          {
            id: 4,
            text: '微应用',
            icon: 'icon-weiyingyong'
          }
        ],
        popularData: []
      }
    },
    computed: {
      ...mapState(['userInfo']),
      ...mapGetters(['getUserLoginStatus', 'getTodoCategory', 'getTodoDept']),
      swiperOption() {
        return {
          notNextTick: true,
          //循环
          loop: false,
          //设定初始化时slide的索引
          initialSlide: 0,
          //自动播放
          autoplay: false,
          // 设置轮播
          effect: 'slide',
          //滑动速度
          speed: 800,
          //滑动方向
          direction: 'horizontal',
          preventDefault: false,
          preventClicksPropagation: false,
          //小手掌抓取滑动
          // grabCursor : true,
          //滑动之后回调函数
          on: {
            slideChangeTransitionEnd: function () {
              console.log(this.activeIndex);//切换结束时，告诉我现在是第几个slide
            },
          },
          //左右点击
          nextButton: `.system .next`,
          prevButton: `.system .prev`,
          //分页器设置
          pagination: '.slide-list-nav',
          paginationClickable: true,
          paginationElement: 'li'
        }
      }
    },
    methods: {
      ...mapMutations(['updateUserInfo', 'updateEmptyListNotice', 'updateTodoCategory', 'updateTodoDept']),
      calendarToToday() {
        this.$refs.calendarComp.toToday();
      },
      toggleAppList() {
        this.appCustom.isAppListShow = !this.appCustom.isAppListShow;
      },
      //待办项滚动标题点击事件
      todoItemTitleClick(data) {
        console.log("个人中心监听到点击事件：");
        console.log(data)
      },
      //切换待办ID
      changeTodoTab(id) {
        this.currentSelectTodoListTab = id;
      },
      // 切换appBoxid
      changeAppTab(id) {
        this.currentSelectAppListTab = id;
      },
      //切换通知公告ID
      changeNoticeTab(id) {
        this.currentSelectNoticeListTab = id;
      },
      changeTodoTabTitle() {

      },
      //打开待办详情
      showTodoDetail(typeid, sysInfo, overview, sendState) {
        /**
         * type
         * 0 overview
         * 1 detail 收到的
         * 2 detail 发出的
         * 3 detail 已办
         * 4 detail 抄送的
         */

        this.$modal.show("todo", {type: typeid, data: sysInfo, overview, sendState})
      },
      //打开通知公告详情
      showNoticeDetail() {
        this.$modal.show("notice")
      },
      //打开日程详情
      showScheduleDetail() {
        this.$modal.show("schedule")
      },
      //编辑待办标题
      editTitle(dat, idx) {
        console.log(idx);
        this.todoListTab[idx].isEdit = !this.todoListTab[idx].isEdit;
      },
      //注销
      async logout() {
        //TODO:注销
        console.log("注销");
        location.replace(apiConfig.REQUEST_URL + "/shall/logoff");
      },

      async initTodoDictData() {
        let todoCategory = await axios.post(apiConfig.REQUEST_URL + '/shall/f_getWorkSort')
        this.updateTodoCategory(todoCategory.data.data)
        let todoDept = await axios.post(apiConfig.REQUEST_URL + '/shall/f_getWorkDept')
        this.updateTodoDept(todoDept.data.data)
      },
      //初始化待办
      async initTodo() {
        let currSelectType = this.todoFilterCate ? this.todoFilterCate.value : -1
        let todoReceive = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getWorkCount?" + this.$qs.stringify({
          pageSize: 3,
          pageNumber: 0,
          state: 1,
          sort: 0,
          typeid: currSelectType,
          deptid: -1
        }));
        let todoSend = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getWorkCount?" + this.$qs.stringify({
          pageSize: 3,
          pageNumber: 0,
          state: 0,
          sort: 0,
          typeid: currSelectType,
          deptid: -1
        }));
        this.todoHandlePathPre = todoSend.data.msg;
        this.todoData.send = todoSend.data.data[0].list.splice(0, 7);
        this.todoData.receive = todoReceive.data.data[0].list.splice(0, 7);
        this.$nextTick(() => {
          this.initTodoDetailList()
        })
      },
      initTodoDetailList() {
        for (let key in this.todoData) {
          this.todoData[key].forEach(async workItem => {
            let type = key === 'send' ? 0 : 1
            let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/front_getWorkList', {}, {
              params: {
                pageNumber: 1,
                pageSize: 3,
                state: -1,
                type,
                sysname: workItem.sysname
              }
            })
            console.log('resp--->>>>>')
            console.log(resp.data.data[0].list)
            workItem.titleList = resp.data.data[0].list
          })
        }

      },
      //初始化个人数据
      async initPersonalInfo() {
        let personalInfo = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getPrivateData");
        this.personalInfo = personalInfo.data.data;
        this.fetchPersonalItemInfo()
      },
      //插入个人数据
      insertValueToPersonalInfo(id, arr) {
        let personalInfoArr = this.personalInfo

        for (let i = 0; i < personalInfoArr.length; i++) {
          if (personalInfoArr[i].id === id) {
            personalInfoArr[i].num = arr
          }
        }
      },
      fetchPersonalItemInfo() {
        this.personalInfo.forEach(async (personalInfo) => {
          let personalInfoData = await axios.post(apiConfig.REQUEST_URL + '/shall/front_getPrivateDataOne?id=' + personalInfo.id)
          this.insertValueToPersonalInfo(personalInfoData.data.msg, personalInfoData.data.data)
        })
      },
      setAppListTab(id) {
        this.appCustom.selectedTab = id;
      },
      setAppListCate(id) {
        this.appCustom.selectedCate = id;
      },

      //通知公告数据
      async initNoticeData() {
        let noticeList = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getNoticeList?" + this.$qs.stringify({
          pageSize: 5,
          pageNumber: 1,
          property: 'title',
          keyword: null,
          sysId: null,
          type: -1
        }));
        noticeList = noticeList.data.data[0].list;
        this.noticeListTab[0].list = noticeList;
        noticeList = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getNoticeList?" + this.$qs.stringify({
          pageSize: 5,
          pageNumber: 2,
          property: 'title',
          keyword: null,
          sysId: null,
          type: -1
        }));
        noticeList = noticeList.data.data[0].list;
        this.noticeListTab[1].list = noticeList;
      },
      //打开通知公告详情
      openNoticeDetail(data) {
        let url = data.url;
        let title = data.title;
        if (data.sysId === 'ehall' && data.state === 0) {
          this.$modal.show("createNotice", {data, url, title});
        } else {
          if(data.appOpenType=='window'){
            window.open(url)
          }else{
            this.$modal.show("noticeDetail", {data, url, title});
          }
        }
      },

      //初始化业务直通车
      async initServiceTrain() {
        let serviceData = await axios.post(apiConfig.REQUEST_URL + "/shall/f_getApplist?type=0,2&terminal=0");
        this.serviceData = serviceData.data.data[0].wfw.filter(item => item.type === 2)
        this.microServiceList = serviceData.data.data[0].wfw.filter(item => item.type === 0)
        Bus.$emit("refreshPersonalServiceTrain", {});
      },
      //加载公共服务
      async initPublicService() {
        let publicServiceData = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getWyyList");
        console.log("publicServiceData", publicServiceData.data.data)
        this.publicService = publicServiceData.data.data;
        for (let i = 0; i < this.publicService.length; i++) {
          if (this.publicService[i].id === 0) {
            this.morePublicService = this.publicService[i].cyfwList
          }
        }
      },
      //设置更多微服务展示
      setMorePublicServiceShow() {
        this.isShowMorePublicService = true
      },
      //设置更多微服务隐藏
      setMorePublicServiceHide() {
        this.isShowMorePublicService = false
      },
      //打开更多服务
      openMoreServiceItem(item) {
        switch (item.name) {
          case '我要议校':
            this.$router.push('/educ')
            break
          case '我要办事':
            this.$router.push('/service')
            break
          default:
            this.openExtraPage(item)
        }
      },
      onMore() {
        this.$router.push({path: "/service"})

      },
      //打开外部页面
      openExtraPage(item) {
        let url = item.pc_url;
        let title = item.name;
        this.$modal.show("extraPage", {url, title, setModalSize: 1, width: '90%', height: '90%'});
      },
      //开放预约
      showOrderPanel() {
        this.$modal.show("orderPanel");
      },
      //人员资料审核
      showProfileVerifyPanel() {
        this.$modal.show("verifyModal", {});
      },
      //通知公告审核
      showNoticeVerifyPanel() {
        this.$modal.show("noticeVerifyModal", {});
      },
      //跳转至个人数据详情
      toPersonalDataDetail(item) {
        if (item.type === 0) {
          this.$notify({
            group: 'global',
            title: '温馨提示',
            text: '当前数据项没有详情！'
          })
          return
        }
        if (item.type < 0) {
          window.open(item.url)
          return
        }
        this.$modal.show("personalData", {personalData: item});
      },
      //切换日程日历
      toggleCalendar() {
        this.$refs.calendarComp.toggleCalendarMode();
      },
      //搜索动作
      async searchAction() {
        let searchResult = await axios.post(apiConfig.REQUEST_URL + '/shall/front_search?' + this.$qs.stringify({
          type: 0,
          pageSize: this.searchPageSize,
          pageNumber: this.searchPageNumber,
          keyword: this.searchText,
          starttime: null,
          endtime: null
        }))
        this.searchResultData = searchResult.data.data[0];
      },
      //执行搜索动作
      execSearchAction() {
        this.isShowSearchArea = true;
        this.searchAction();
      },
      //搜索结果处理
      searchToScheduleDetail(schItem) {
        this.$modal.show("scheduleDetail", [schItem])
      },
      //打开搜索待办办理页面
      openDetail(data) {
        let url = data.url;
        let title = data.title;
        this.$modal.show("extraPage", {url, title});
      },
      //打开消息详情
      openMsgDetail(msg) {
        this.$modal.show("messageDetail", msg);
      },
      //关闭搜索
      closeSearch() {
        this.searchText = ''
        this.isShowSearchArea = false
      },
      //获取数据键字符串
      getSearchKeyByType(type) {
        switch (type) {
          case 1:
            return 'schedule'
          case 2:
            return 'message'
          case 3:
            return 'notice'
          case 4:
            return 'work'
          default:
            console.log('getSearchKeyByType参数异常')
            return 0
        }
      },
      //搜索结果局部加载下一页
      async searchListLoadMore(data, type) {
        if (data.pageNumber >= data.pageCount) {
          return;
        }
        data.pageNumber++
        let searchResult = await axios.post(apiConfig.REQUEST_URL + '/shall/front_search?' + this.$qs.stringify({
          type: type,
          pageSize: this.searchPageSize,
          pageNumber: data.pageNumber,
          keyword: this.searchText,
          starttime: null,
          endtime: null
        }))

        searchResult = searchResult.data.data[0]

        let newData = searchResult[this.getSearchKeyByType(type)]
        data.pageNumber = newData.pageNumber
        newData.list.forEach((item, index) => {
          data.list.push(item)
        })
      },
      openProfiles() {
        return false;
        let userType = parseInt(this.userInfo.userType)
        if (userType !== 1 && userType !== 2) {
          this.$notify({
            group: 'global',
            title: '温馨提示',
            text: '当前用户无需修改用户资料！'
          })
          return
        }

        this.$modal.show('profile', {generalOperate: true})
      },
      openTodoHandle(ev) {
        if (!ev.url) {
          this.showTodoDetail(0, {})
          return
        }
        let url = this.todoHandlePathPre + ev.url;

        //如果标记为新窗口打开
        if (ev.appOpenType === 'window') {
          window.open(url)
          return
        }
        //网页框架中打开
        let title = ev.title;
        this.$modal.show("extraPage", {url, title});
      },
      openImageReplace(url) {
        this.$modal.show('profileAvatarModal', {imgURL: url, imgType: 0})
      },
      //初始化个人资料
      async initUserInfo() {
        let userInfo = await axios.post(apiConfig.REQUEST_URL + "/shall/front_userInfo").catch(() => {
          //TODO:重定向错误页
        });
        this.updateUserInfo(userInfo.data.data[0]);
        this.$nextTick(() => {
          this.$refs.avatarImageDOM.reload()
        })
      },
      //获取天气
      async getWeather() {
        let weatherInfo = await axios.post(apiConfig.REQUEST_URL + "/shall/f_getWeather");
        console.log(weatherInfo)
        if (weatherInfo.data.status) {
          weatherInfo = JSON.parse(weatherInfo.data.data[0]).result;
        }
        if (!weatherInfo) {
          this.weatherInfo = '暂未获取到天气'
          return
        }
        let city = weatherInfo.city;
        let overview = weatherInfo.future[0].weather;
        let temperature = weatherInfo.future[0].temperature.replace(/\//g, '~');
        this.weatherInfo = `${city} ${overview} ${temperature}`
      },
      //初始化提示文案
      async initEmptyListNotice() {
        let noticeList = await axios.post(apiConfig.REQUEST_URL + '/shall/front_getMarkedWords')
        if (noticeList.data.status) {
          return
        }
        noticeList = noticeList.data.data
        this.updateEmptyListNotice(noticeList)
      },
      selectTodoCate() {
        this.$nextTick(() => {
          this.initTodo()
        })
      },
      closeCenter() {
        this.centerStatus = false
      },
      onLeftMenu(e, text) {
        this.currentLeftText = text
        this.systemAppName = text
        this.systemAppList = []
        if (e === 2) {
          this.getSystemList(1)
        } else if (e === 3) {
          this.getSystemList(2)
        } else if (e === 4) {
          this.getSystemList(0)
        }
        if (this.centerStatus) {
          if (this.centerCode === e) {
            this.centerStatus = false
            this.currentLeftText = ''
          } else {
            this.centerCode = e
          }
        } else {
          this.centerStatus = true
          this.centerCode = e
        }
      },
      onItem(e) {
        if (e.appOpenType === 'frame') {
          this.$modal.show("extraPage", {url: e.pc_url, title: e.name});
          return
        } else if (e.appOpenType !== 'frame') {
          window.open(e.pc_url)
          return;
        }

      },
      async getSystemList(e) {
        console.log(e);
        let serviceListData = await axios.post(apiConfig.REQUEST_URL + "/shall/f_getApplist?" + this.$qs.stringify({
          type: e,
          terminal: 0
        }))
        console.log(serviceListData);
        if (e === 1) {
          this.systemAppList = serviceListData.data.data[0].online
        } else {
          this.systemAppList = serviceListData.data.data[0].wfw
        }

      },
      async getCopyto() {
        let copyData = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getCarbonCopyMsgTotalForUser")
        this.copyData = copyData.data.data[0].splice(0, 7);
      },
      showCreateNotice() {
        this.currentLeftText = '发布通知公告'
        this.$modal.show("createNotice", {});
      },
      getDate() {
        let value = new Date()
        let y = value.getFullYear(),
        m = value.getMonth() + 1,
        d = value.getDate(),
        h = value.getHours(),
        f = value.getMinutes(),
        s = value.getSeconds()
        this.currentTimeInfo = y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + ' ' + h + ':' + f + ':' + (s < 10 ? "0" + s : s)
      },
      setCurrTime() {
        setInterval(() => {
          this.currTime = getOneDayCustomDateStr(new Date())
        }, 1000)
      },
      onService() {

      },
      //初始化热门数据
      async initPopularService() {
        // f_hotService?num=8
        let popularServiceData = await axios.post(apiConfig.REQUEST_URL + "/shall/f_getApplist?terminal=0&type=5");
        console.log(popularServiceData);
        popularServiceData = popularServiceData.data.data[0].wfw;
        if (popularServiceData.length > 8) {
          this.popularData = popularServiceData.splice(8, popularServiceData.length);
        } else {
          this.popularData = popularServiceData
        }
      },
    },
    watch: {
      searchText(newVal) {
        console.log('searchText值变化：' + newVal);
        if (!newVal) {
          this.isShowSearchArea = false;
        } else {
          this.isShowSearchArea = true;
          if (this.searchInWaiting) {
            clearTimeout(this.searchInWaiting)
          }
          this.searchInWaiting = setTimeout(() => {
            this.searchAction();
          }, 1000)
        }
      }
    },
    filters: {
      noticeTimeFilter(e) {
        return e.substring(0, 10)
      },
      templateReplace(desc, num) {
        let result = desc;
        let reg = /{data}/;

        if (num === null || num === undefined) {
          num = 0
        }
        if (!num.length) {
          result = result.replace(/{data}/g, '<span class="weight">0</span>')
          return result
        }

        num.forEach((item, index) => {
          if (!item) {
            item = '<span class="weight">0</span>'
          }
          result = result.replace(reg, `<span class="weight">${item}</span>`)
        });

        return result;

      },
      convertTimeToDate(val) {
        if (val) {
          return val.split(" ")[0]
        }
      }
    },
    components: {
      VueTabs,
      VTab,
      servicebox,
      calendar,
      scrollTitle,
      personalData,
      switchComp,
      sysNavSort,
      multiselect,
      rating,
      serviceModel,
      slideAppList,
      breathText,
      serviceDetail
    },
    mounted() {


      this.iframePrefix = apiConfig.MICRO_APP_URL
      this.clientHeight = window.screen.height - 150
      this.getCopyto()
      this.getSystemList()
      this.getWeather()
      this.initTodo();
      this.initTodoDictData()
      this.initPersonalInfo();
      this.initNoticeData();
      this.initServiceTrain();
      this.initPublicService();
      this.initEmptyListNotice();
      this.initPopularService();
      this.timer = setInterval(() => {
        this.getDate()
      }, 100)
      //this.$modal.show('courseTableModal')
      Bus.$on("modalSlidesClose", () => {
      })
      Bus.$on("noticeChange", () => {
        this.initNoticeData();
      });
      Bus.$on("todoHandleFinish", () => {
        this.initTodo();
      });
      Bus.$on('personalAvatarChange', this.initUserInfo)
      Bus.$on('refreshSysNavList', (ev) => {
        this.initServiceTrain();
      });
      this.$nextTick(() => {
        console.log(this.$refs)
        this.$refs.calendarComp.toToday()
      })
      this.setCurrTime()

    },
    beforeDestroy() {
    }
  }
</script>

<style lang="stylus" scoped>


  @import "../common/stylus/placeholder.styl"
  @import "../common/stylus/config.styl"

  .personal
    width 100%
    min-width 1400px
    padding 80px 20px 50px 20px
    box-sizing border-box
    @media screen and (max-width: 1300px)
      padding-top 120px !important
      zoom 0.4 !important
    @media screen and (max-width: 1800px)
      padding-top 120px !important
      zoom 1 !important

    .leftside
      width 130px
      height 838px
      float left
      border-radius 8px
      background #ffffff
      border 1px solid #eeeeee
      position relative

    .oneTable
      text-align right

      .label
        display inline-block
        width 100px
        height 20px
        line-height 20px
        margin-right 10px
        margin-bottom -10px
        background-color #E1E6EB
        font-size 10px
        text-align center
        white-space nowrap
        position relative
        top 10px
        color #FF3336
        cursor pointer

    .fix-container
      z-index 99
      //个人资料

      .profile
        margin-top 10px
        text-align center

        &::after
          content ""
          display block
          margin auto
        @media screen and (max-width: smallScreenWidth)
          margin-top 0

        .avatar
          height 114px
          position relative

          img, span
            display block
            width 82px
            height 82px
            border-radius 50%
            position absolute
            left 0
            right 0
            top 0
            bottom 0
            margin auto

          img
            z-index 9
            /*background-color #00f*/
            border 1px solid #ffffff

          span
            z-index 8
            background-image url(../assets/images/avatar_default.png)
            background-size cover

        .username
          font-size 18px
          color #333333
          cursor pointer
          text-align center
          transition 300ms
          font-weight bold

        .userzw
          font-size 16px
          color #666666
          margin-top 8px

      .toolslist
        width 100%
        margin auto
        padding-top 24px
        position relative
        @media screen and (max-width: smallScreenWidth)
          padding-top 0
          margin-top 10px

        .currentRed
          background themeColor

          i
            color #ffffff

          p
            color #ffffff

        li
          height 40px
          line-height 40px
          border-radius 3px
          transition 300ms
          cursor pointer
          margin-bottom 4px
          position relative
          box-sizing border-box
          white-space nowrap

          & > *
            vertical-align top

          span
            display inline-block
            width 30px

          img
            border-radius 5px
            background-color #ffffff

          p
            display inline-block !important
            overflow hidden
            white-space nowrap
            text-overflow ellipsis
            width 100px
            margin-left 0

          &:hover
            background-color themeColor

            i
              color #ffffff

            p
              color #ffffff

          img
            width 26px
            height 26px
            vertical-align middle

          i
            color #b7b9bb
            font-size 15px

          p
            margin-left -6px
            font-size 16px
            color #313131
            display inline
            font-weight bold
            text-overflow clip

          .moreServiceContainer
            max-height 400px
            overflow-y scroll
            z-index 9999999999
            background-color #ffffff
            width 200px
            position absolute
            bottom 0
            left 100%
            border 1px solid #eeeeee
            border-radius 10px
            box-shadow 1px 1px 8px #999999

            .emptyList
              text-align center
              padding-left 0
              margin-bottom 0
              font-size 16px
              color #666666
              user-select none

              &:hover
                background-color #ffffff

        .popularTitleBox
          width 100%
          margin-top 15px
          margin-bottom 10px

          .box
            width 66px
            height 20px
            background themeColor
            color #ffffff
            font-size 16px
            text-align center
            line-height 20px

    .center
      height 100%
      background #ffffff
      border-radius 8px
      box-shadow 0 0px 10px #ccc
      overflow hidden
      position absolute
      left 0
      top 0
      transition 300ms
      z-index 999

      .use
        width 552px
        height 100%

    .mainContainer
      width 90%
      height 100%
      transition 300ms
      float right
      position relative

      .header
        height 30px

        .right
          width 400px
          float right
          color #666666
          font-size 16px
          line-height 30px

          span
            margin-left 20px

        .left
          height 100%
          overflow hidden
          padding-right 20px
          position relative

          .inner
            position absolute
            left 0
            right 20px
            top 0
            bottom 0
            background #ffffff
            border-radius 5px
            overflow hidden

            input.searchinput
              height 100%
              width 90%
              font-size 16px
              outline none
              color #666666
              padding-left 12px

            button
              width 59px
              height 30px
              text-align center
              border none
              background-color themeColor
              outline none
              position absolute
              right 0
              top 0

            i
              font-size 19px
              color #ffffff

      .searchResult
        background #ffffff
        min-height 600px
        max-height 96%
        overflow-y scroll
        margin-top 15px
        padding 25px
        border-radius 8px

        .searchNotice
          font-size 16px
          color #666666

          span
            color #f48b4b
            margin 0 5px
            font-weight bold

          .back
            float right
            width 60px
            height 30px
            background none
            border 1px solid #cccccc
            color #666666
            outline none
            transition 300ms
            border-radius 5px
            margin-top -10px
            margin-right 5px

            &:hover
              background-color #eeeeee

        .group
          & > h2
            font-size 16px
            color #999999
            line-height 20px
            padding-left 10px
            border-left 5px solid themeColor
            margin-bottom 30px
            margin-top 20px

          .resultlist
            li
              padding-left 20px
              margin-top 10px
              border-bottom 1px solid #eeeeee
              padding-bottom 10px

              &:hover h3, &:hover p
                cursor pointer
                color #333333

              &:hover h3::before
                transform translateX(5px)

              h3
                color #666666
                font-size 16px
                line-height 26px
                padding-left 20px
                position relative
                white-space nowrap
                overflow hidden
                text-overflow ellipsis

                &::before
                  content ""
                  display block
                  width: 0;
                  height: 0;
                  border-top: 5px solid transparent;
                  border-left: 6px solid themeColor;
                  border-bottom: 5px solid transparent;
                  position absolute
                  left 0
                  top 0
                  bottom 0
                  margin auto
                  transition 300ms

              p
                color #999999
                font-size 16px
                line-height 26px
                height 26px
                overflow hidden

              span
                color #999999
                font-size 16px
                line-height 26px
                float right
                margin-top -26px

          .loadmore
            width 160px
            margin 20px
            border 1px solid #cccccc
            text-align center
            border-radius 10px
            line-height 30px
            color #666666
            font-size 16px
            cursor pointer
            transition 300ms
            user-select none

            &:hover
              border-color themeColor
              color themeColor

      .row
        font-size 0
        margin-top 20px

        & > div
          height 406px

          &.left
            width 378px
            float left

          &.right
            width 400px
            float right

          &.middle
            overflow hidden
            margin 0
            position relative

            .inner
              position absolute
              left 20px
              right 0
              top 0
              bottom 0

          &.half
            display inline-block
            height 337px
            position relative

            .inner
              position absolute
              top 0
              bottom 0

            &:nth-of-type(1)
              .inner
                left 0
                right 10px

            &:nth-of-type(2)
              .inner
                left 10px
                right 0

        .noticeBox
          height 100%
          background #ffffff
          border-radius 8px
          margin-left 20px
          overflow hidden

          .noticeTitle
            width 100%
            height 50px
            padding-left 20px
            padding-right 18px
            box-sizing border-box

            .noticeTitleLeft
              width 40%
              height 100%
              line-height 50px
              float left

              h2
                color themeColor
                font-size 16px
                font-weight bold

            .noticeTitleRight
              float right
              color #ACB5C2
              font-size 16px

              .noticeOptions
                height 100%
                line-height 50px
                float left
                margin-right 25px

                span
                  margin-left 12px
                  cursor pointer

                .optionsActive
                  font-weight bold
                  color themeColor

              .detail
                height 50px
                line-height 50px
                float right
                cursor pointer

          .noticeCon
            width 100%
            height 287px
            padding 0 20px
            box-sizing border-box

            .noticeItem
              width 100%
              height 50px
              line-height 50px
              border-bottom 1px solid #EEEEEE
              cursor pointer

              .noticeItemLeft
                width 60%
                height 100%
                overflow hidden
                white-space nowrap
                text-overflow ellipsis
                float left
                font-size 20px
                color #707070

              .noticeItemRight
                float right
                font-size 20px
                color #707070

        .appBox
          height 337px
          background #fff
          border-radius 8px
          font-size 16px

          .appTitle
            width 100%
            height 50px
            line-height 50px
            padding 0 20px
            box-sizing border-box

            .appTitleLeft
              float left

              .appOptions
                width 100%
                height 100%

                .appOptionsItem
                  float left
                  font-size 16px
                  color #999D9D
                  margin-right 30px
                  cursor pointer

                .appOptionsItemActive
                  color themeColor
                  font-size 20px

                  span
                    font-weight bold

            .appTitleRight
              float right
              font-size 16px
              color #acb5c2
              cursor pointer

          .appCon
            width 100%
            height 287px

        .module
          background-color #FFFFFF
          border-radius 8px

          & > h2
            background none
            background-color #ffffff
            color themeColor
            font-size 20px
            font-weight bold
            padding-left 20px !important

    .main
      width 90%
      height 100%
      transition 300ms
      float right
      position relative
      padding-right 405px

      .header
        width 100%
        height 30px

        .search
          width 100%
          height 100%
          border-radius 5px
          overflow hidden
          background #ffffff
          position relative

          input.searchinput
            height 100%
            width 90%
            font-size 16px
            outline none
            color #666666
            padding-left 12px

          button
            width 59px
            height 30px
            text-align center
            border none
            background-color themeColor
            outline none
            position absolute
            right 0
            top 0

          i
            font-size 19px
            color #ffffff


      .main-right
        width 380px
        height 100%
        position absolute
        top 0
        right 0

        .box
          width 100%
          height 100%
          position relative
          padding-top 525px

        .mr-top
          width 100%
          height 500px
          background #ffffff
          position absolute
          top 0
          left 0
          border-radius 8px
          overflow hidden

        .mr-bottom
          width 100%
          height 100%
          background #ffffff
          border-radius 8px
          overflow hidden

      .main-mb
        width 100%
        height 100%
        position absolute
        top 0
        left 0
        transition 300ms

        z-index 666


      .serviceBox
        width 100%
        height 96%
        background #ffffff
        margin-top 15px
        padding 15px 0px 25px 0px
        box-sizing border-box
        overflow hidden
        border-radius 8px

      .iframeBox
        background #ffffff
        height 96%
        margin-top 15px
        padding 25px
        border-radius 8px

        iframe
          width 100%
          height 100%


      .personalProfile
        &::after
          content ""
          display block
          width 100%
          clear both

      .row
        /*overflow hidden*/
        margin-bottom 10px

        &::after
          content ""
          width 100%
          display block
          clear both

      .row
        .short
          width 375px

        .long
          overflow hidden
          padding-right 18px

      .row.toleft .short
        float left

      .row.toleft .long
        padding-left 18px

      .row.toright .short
        float right

      .row.toright .long
        padding-right 18px

      .row.toside
        padding-right 18px

        .left
          float left
          margin-right 18px

        .right
          float right

      /*margin-left 18px*/

      .block
        .general
          border-radius 5px
          background-color #ffffff
          width 100%
          margin-bottom 10px

  /**
    组件的样式
   */
  .todo
    position relative

    .nav-tabs-wrapper
      text-align right

    .filterContainer
      width 180px
      height 26px
      display inline-block
      padding 0 18px
      box-sizing border-box
      text-align left
      margin-top 12px
      //@media screen and (max-width: 1680px)
      //  position absolute
      //  left 0
      //  top 45px

      & >>> .multiselect
        width 100%
        height 26px
        background-color #ffffff
        border-radius 3px !important

        .multiselect__single
          line-height 26px
          position relative
          top -4px

        .multiselect__placeholder
          position relative
          top -4px

    .nav-tabs-wrapper
      padding 0 18px
      box-sizing border-box

    & >>> .nav-tabs
      cursor pointer

      &::after
        content ""
        display block
        width 100%
        height 0
        clear both

      .tab
        max-width 186px
        height 50px
        line-height 50px
        font-size 16px
        background-color none
        border-radius 0
        float left
        text-align center
        margin-right 20px

        .editTitle
          width 100px
          color #666666
          text-align center
          font-size 16px
          border-bottom 1px solid #cccccc

        .edit
          margin-left 10px
          cursor pointer
          opacity 0

          i
            color #999999
            transition 300ms

            &:hover
              color #666666

        &:hover .edit
          //TODO:待办改标题功能
          opacity 1

        a
          color #999
          font-size 16px

        &:first-of-type

          .active_tab
            border none
            background none

        &.active
          position relative

          .active_tab
            color themeColor
            font-size 16px

            span
              font-weight bold

    .copyTo
      li
        width 100%

        span:nth-child(1)
          float left
          font-size 16px
          font-weight bold
          color #333
          line-height 1.2
          white-space nowrap
          overflow hidden
          text-overflow ellipsis

        span:nth-child(2)
          float right
          font-size 16px
          line-height 1.2

    .todolist
      width 100%
      padding 0 18px
      padding-top 20px
      box-sizing border-box
      height 82%
      overflow-y scroll

      &::-webkit-scrollbar
        width 0px

      & > .noticeText
        font-size 16px
        color #666666
        line-height 300px
        text-align center

      li
        transition 300ms
        cursor pointer
        clear both
        padding-top 20px
        padding-bottom 20px
        overflow hidden
        border-bottom 1px solid #EEEEEE
        min-height 105px !important

        .icon
          width 60px
          height 60px
          text-align center
          border-radius 50%
          overflow hidden
          float left
          padding 0
          /*background-image url(../assets/images/todo_icon.png)*/
          background-repeat no-repeat
          background-position center center

          img
            width 100%
            height 100%

        .info
          width 80%
          float left
          margin-left 11px

          h2
            font-size 16px
            font-weight bold
            color #333333
            line-height 1.5
            white-space nowrap
            overflow hidden
            text-overflow ellipsis

            &.hold
              margin-top 2px
              line-height 2

            p
              display inline-block
              float right
              margin-top -5px
              color #999999
              font-size 16px

          p
            font-size 16px
            color #666666
            line-height 1.8
            margin-bottom 3px

          div
            white-space nowrap
            display block
            overflow hidden

            p
              white-space nowrap
              line-height 20px
              float left
              font-size 16px
              color #b2b2b2
              overflow hidden;
              text-overflow ellipsis
              @media screen and (max-width: smallScreenWidth)
                margin-right 10px

              span
                display block
                width 20px
                height 20px
                line-height 20px
                text-align center
                color #ffffff
                font-size 16px
                border-radius 50%
                margin-right 4px
                float right

              &:first-of-type > span
                color #F15153

              &:nth-of-type(2) > span
                color themeColor

              &:last-of-type
                width 66px
                float right
                margin-right 38px

    &::after
      content ""
      display block
      width 100%
      height 1em
      position absolute
      bottom 0
      background-color #ffffff

    & > .title
      width 120px
      height 50px
      line-height 50px
      color #333333
      font-size 16px
      position absolute
      left 0
      top 0
      padding-left 15px
      font-weight bold

      &::after
        content ""
        display block
        border 1px solid #f1f1f1
        height 20px
        position absolute
        right 0
        top 0
        bottom 0
        margin auto

    & >>> .nav-tabs
      //border-bottom 1px solid #ebebeb
      //background linear-gradient(#ffffff, #fafafa)
      //background-color #fdfdfd
      cursor pointer

      &::after
        content ""
        display block
        width 100%
        height 0
        clear both

      .tab
        max-width 186px
        height 50px
        line-height 50px
        font-size 20px
        font-weight bold
        background-color none
        border-radius 0
        float left
        text-align center
        margin-right 20px

        .title
          font-weight bolder

        &.active
          a
            color themeColor

          &::after
            content ""
            display none
            width 28px
            height 2px
            position absolute
            left 0
            right 0
            margin auto
            bottom 0
            background-color themeColor

          &::before
            content ""
            display none
            width 0
            height 0
            position absolute
            left 0
            right 0
            margin auto
            bottom 0
            border-left: 6px solid #fff;
            border-right: 6px solid #fff;
            border-bottom: 6px solid themeColor;
            background-color themeColor

    .arclist
      padding 12px 7px 10px 18px
      height 300px
      overflow hidden
      background-color #ffffff

      li
        height 51px
        border-bottom 1px solid #f3f3f3
        cursor pointer
        overflow hidden

        &:hover p
          color themeColor


        p, span
          line-height 50px
          color #333333
          font-size 16px

        p
          float left
          max-width 260px
          white-space nowrap
          overflow hidden
          text-overflow ellipsis
          transition 300ms

          .edit
            color themeColor
            padding 1px
            border-radius 50%
            margin-right 6px
            border 1px solid themeColor

          .verify
            border none
            color themeColor
            font-size 18px
            vertical-align middle

          .reject
            border none
            color themeColor
            font-size 24px
            vertical-align middle

          .inTop
            color themeColor
            margin-right 6px

        span
          float right

  .calendar
    /*border 5px solid #00f*/
    /*padding-bottom 10px*/
    height 422px

    .title
      color #333333
      height 50px
      line-height 50px
      font-size 16px
      border-bottom 1px solid #ebebeb
      background-color #fdfdfd
      background linear-gradient(#ffffff, #fafafa)
      padding-left 15px
      border-bottom 1px solid #ebebeb
      font-weight bold

      i
        /*margin-left 10px*/
        padding 0 10px
        cursor pointer
        transition 300ms
        display inline-block
        height 1em
        line-height 1em
        vertical-align middle
        transform-origin center center
        border 1px solid transparent

        &:hover
          transform rotateZ(180deg)

      span
        float right
        color #333333
        font-size 16px

    .info
      height 85px
      border-bottom 1px solid #ebebeb
      font-size 16px
      color #333333
      line-height 85px
      position relative

      & > i
        line-height 85px
        color #464646
        font-size 30px
        transform rotateZ(-30deg)
        float left
        margin-left 26px
        margin-right 14px

      span
        float right
        display block
        line-height 1
        position absolute
        top 0
        bottom 0
        right 26px
        height 1em
        margin auto
        font-size 22px

        i
          line-height inherit
          font-size inherit

  .addApp
    .content
      position relative

      .add
        position absolute
        width 88px
        height 80px
        left 0
        right 0
        top 0
        bottom 0
        margin auto
        padding-top 10px
        text-align center
        cursor pointer

        &:hover i, &:hover p
          color #666666

        i, p
          transition 300ms
          user-select none

        i
          width 42px
          height 42px
          color #acaebc
          padding-top 10px
          text-align center
          font-size 40px
          margin-top 10px

        p
          margin-top 10px
          font-size 16px
          color #acaebc

  .personalData

    .datalist
      height 100%
      overflow-y scroll
      padding 15px
      padding-bottom 0

      li
        overflow hidden
        padding 5px 0
        border-bottom 1px solid #eeeeee
        cursor pointer
        transition 300ms

        &:hover
          background-color #eeeeee

        .item-icon
          width 45px
          height 45px
          text-align center
          border-radius 15px
          float left
          margin 7px 10px

          img
            width 100%
            height 100%

        h2
          margin-top 14px
          font-size 18px
          color #666666
          font-weight bold

        p
          margin-top 6px
          font-size 18px
          color #585858

  .module
    transition 300ms
    position relative


    .detail
      cursor pointer
      height 50px
      line-height 50px
      text-align right
      font-size 16px
      color themeColor
      transition 300ms
      float right

      &:hover
        color themeColor

    & > h2
      height 50px
      padding-left 24px
      line-height 50px
      font-size 16px
      color #333333
      background linear-gradient(#f9f9f9, #f5f5f5)

    & > .content
      height 346px


  /*应用列表*/
  .applistmask
    position fixed
    left 0
    right 0
    top 0
    bottom 0
    background-color rgba(0, 0, 0, 0.2)
    z-index 100

  .applist
    width 480px
    height 100%
    position fixed
    left 0
    top 0
    bottom 0
    background-color #ffffff
    z-index 999
    box-shadow 2px 2px 3px #cccccc

    .tablist
      font-size 0
      border-bottom 1px solid #eeeeee

      li
        font-size 16px
        color #666666
        line-height 31px
        text-align center
        width 33.3%
        display inline-block
        border-right 1px solid #eee
        position relative
        cursor pointer

        &:hover .line
          transform scaleX(1)

        &:last-of-type
          border-right none

        i
          font-size 10px
          margin-bottom 5px
          margin-right 5px
          vertical-align baseline

        .line
          height 2px
          background-color themeColor
          position absolute
          left 0
          right 0
          bottom 0
          transition 300ms
          transform scaleX(0)

        &.on
          color themeColor

          span.line
            transform scaleX(1)

    .search

      border 1px solid #cccccc
      width 400px
      margin auto
      margin-top 10px
      height 30px
      position relative
      border-radius 15px
      overflow hidden

      i
        position absolute
        display block
        left 10px
        font-size 20px
        width 30px
        height 30px
        line-height 32px
        text-align center

      input
        color #666666
        font-size 16px
        height 100%
        width 350px
        margin-left 40px

    .contentList
      position absolute
      top 80px
      bottom 0
      width 100%
      margin-top 10px

      .left
        float left
        width 120px

        li
          height 32px
          line-height 32px
          padding-left 0.6em
          font-size 16px
          color #666666
          position relative
          border-bottom 1px solid #eeeeee
          cursor pointer
          transition 300ms

          &:hover
            background-color #eeeeee

          &.on
            background-color themeColor
            color #ffffff

            &::before
              content ""
              display block
              position absolute
              left 0
              top 0
              bottom 0
              width 2px
              background-color themeColor

      .right
        border 1px solid #eeeeee
        position absolute
        right 0
        left 120px
        top 0
        bottom 0
        overflow-y scroll

        .building
          height 100px
          line-height 100px
          font-size 16px
          color #666666
          text-align center

        li
          border-bottom 1px solid #eeeeee
          height 32px
          line-height 32px
          position relative

          &::after
            content ""
            display block
            clear both
            width 100%

          img
            display block
            margin-top 4px
            margin-left 10px
            margin-right 5px
            width 24px
            height 24px
            float left

          p
            width 200px
            float left
            font-size 16px
            color #666666

          span1
            position absolute
            display block
            right 10px
            top 0
            bottom 0
            margin auto
            width 40px
            height 20px
            border-radius 10px
            border 1px solid #cccccc
            text-align center
            line-height 20px
            cursor pointer
            transition 300ms

            &:hover
              background-color #eeeeee

            i
              display block
              line-height 18px
              font-size 16px
              color #666666

    .close
      width 20px
      height 100px
      position absolute
      right -20px
      top 0
      bottom 0
      margin auto
      border-top-right-radius 10px
      border-bottom-right-radius 10px
      background-color #ffffff
      box-shadow 2px 2px 3px #cccccc
      cursor pointer

      &:hover i
        color #333333

      i
        line-height 100px
        color #999999
        text-shadow 2px 2px 2px #cccccc
        font-size 16px
        text-align center

  .appListAnim-enter-active, .appListAnim-leave-active {
    transition: all .3s;
  }

  .appListAnim-enter, .appListAnim-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
    transform translateX(-400px)
  }


  .tabToggle-enter-active, .tabToggle-leave-active
    transition: all .3s;

  .tabToggle-enter, .tabToggle-leave-to
    position absolute
    transform translate3d(-50px, 0, 0)
    opacity 0


  /*绿色版皮肤*/

  .green
    /*个人资料*/

    .personal
      //应用管理

      .applist .tablist li.on
        color greenThemeValue

      .applist .tablist li .line, .applist .tablist li.on span.line
        background-color greenThemeValue

      .applist .contentList .left li.on
        background-color greenThemeValue

      .leftside .profile
        .avatar span
          background-image url(../assets/images/avatar_default_lv.png)

        .job
          background-color greenThemeValue

      .notice
        .arclist li:hover p
          color greenThemeValue

        .arclist li p
          .inTop, .edit, .verify, .reject
            border-color greenThemeValue
            color greenThemeValue

      .notice >>> .nav-tabs
        .active
          a
            color greenThemeValue

          &::after, &::before
            border-bottom-color greenThemeValue
            background-color greenThemeValue

      .todo
        & >>> .nav-tabs
          .active
            .active_tab
              color greenThemeValue !important

        .todolist
          li
            .icon
              background-repeat no-repeat

  /*background-image url(../assets/images/todo_icon_lv.png)*/


</style>
<style lang="stylus">
  @import "~common/stylus/config.styl"
  .personalData
    .datalist
      li p
        .weight
          color themeColor
          font-weight normal
          margin 0 2px
</style>



// WEBPACK FOOTER //
// src/pages/personal.vue